'use client'
import { useQuery } from '@tanstack/react-query'
import { IListPostReviewProps, IListReviewByCustomerProps } from '../types/review'
import { getCustomerReviewSummary, getListReviewsByCustomer, reviewService } from '../services'

export const useListReview = ({ productId, params, options, enabled = true }: IListPostReviewProps) => {
  return useQuery({
    queryKey: ['listReview', productId, params],
    queryFn: async () => {
      const res = await reviewService.getListReview({ params, productId, options })
      if (res?.status === 'success' && res?.data) {
        return res?.data
      }
      return null
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
    retry: 2, // Retry failed requests 2 times
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff,
    enabled: !!productId && enabled, // Only run the query if productId is provided
    placeholderData: (previousData) => previousData,
  })
}

export const useListReviewsByCustomer = ({ params }: IListReviewByCustomerProps) => {
  return useQuery({
    queryKey: ['LIST_REVIEW_BY_CUSTOMER', params], // Thêm params vào queryKey để auto refetch
    queryFn: async () => {
      const res = await getListReviewsByCustomer({ params })
      if (res?.status === 'success' && res?.data) {
        return res?.data
      }
      return null
    },
  })
}

export const useCustomerReviewsSummary = () => {
  return useQuery({
    queryKey: ['GET_CUSTOMER_REVIEW_SUMMARY'],
    queryFn: async () => {
      const res = await getCustomerReviewSummary()
      if (res?.status === 'success' && res?.data) {
        return res?.data
      }
      return null
    },
  })
}
